import { cn } from "@/lib/cn";

/**
 * Horizontal or vertical hairline divider. Replaces inline `border-t
 * border-line-subtle` and `h-3 w-px bg-line-subtle` blocks.
 *
 * Use `orientation="vertical"` between toolbar groups (height = parent
 * row); `horizontal` (default) for section breaks inside cards/panes.
 */
export function Divider({
  orientation = "horizontal",
  className,
}: {
  orientation?: "horizontal" | "vertical";
  className?: string;
}) {
  if (orientation === "vertical") {
    return <span aria-hidden className={cn("inline-block h-4 w-px bg-line-subtle", className)} />;
  }
  return <hr aria-hidden className={cn("border-0 border-t border-line-subtle my-2", className)} />;
}
